/** Task type options for the custom dropdown (no default grid editor). */
export const TASK_TYPE_OPTIONS = [
  { key: 'unknown', label: 'Unknown' },
  { key: 'phase', label: 'Phase' },
  { key: 'location', label: 'Location' },
  { key: 'construction_activity', label: 'Construction Activity' },
  { key: 'preparatory_activity', label: 'Preparatory Activity' },
] as const;
